/**
 * TanStack Query Client Configuration
 * 统一管理 React Query 客户端实例
 */

import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // 失败后自动重试 2 次
      retry: 2,
      // 页面隐藏时保留数据，不自动重新获取
      gcTime: 5 * 60 * 1000, // 5 分钟
      // 窗口重新聚焦时重新获取 stale 数据
      refetchOnWindowFocus: true,
      // 重试延迟：指数退避
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
    },
    mutations: {
      // 突变操作失败后不自动重试
      retry: 0,
    },
  },
});

/**
 * Query Keys 工厂函数
 * 统一管理所有 query key，避免 key 不一致
 */
export const queryKeys = {
  // 任务相关
  bounties: {
    all: ["bounties"] as const,
    hall: (filters: { category?: string; search?: string; sort?: string; page?: number }) =>
      [...queryKeys.bounties.all, "hall", filters] as const,
    my: (userId: string) => [...queryKeys.bounties.all, "my", userId] as const,
    detail: (bountyId: string) => [...queryKeys.bounties.all, "detail", bountyId] as const,
    applications: (bountyId: string) =>
      [...queryKeys.bounties.all, "applications", bountyId] as const,
    deliveryHistory: (bountyId: string) =>
      [...queryKeys.bounties.all, "delivery", "history", bountyId] as const,
  },

  // 用户相关
  user: {
    profile: (userId: string) => ["user", "profile", userId] as const,
    skills: (userId: string) => ["user", "skills", userId] as const,
    reputation: (userId: string) => ["user", "reputation", userId] as const,
  },

  // 积分相关
  points: {
    balance: (userId: string) => ["points", "balance", userId] as const,
    transactions: (userId: string, page: number) =>
      ["points", "transactions", userId, page] as const,
  },

  // 通知相关
  notifications: {
    all: (userId: string) => ["notifications", userId] as const,
    unread: (userId: string) => ["notifications", userId, "unread"] as const,
  },
} as const;
